<template>
  <div v-if="visible" class="beneficiary-modal-overlay" @click="handleCancel">
    <div class="beneficiary-modal" @click.stop>
      <div class="beneficiary-modal-header">
        <div class="beneficiary-modal-title">重要提示</div>
        <div class="beneficiary-modal-close" @click="handleCancel">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <div class="beneficiary-modal-content">
        <p class="beneficiary-modal-tip">
          请仔细核验本次登记的账户权益人信息，权益成功激活后，所有服务仅限权益登记本人享有；权益一旦激活生效，保障受益人信息将锁定，不可申请修改、替换。
        </p>

        <div class="beneficiary-info-card">
          <div class="beneficiary-info-row">
            <span class="beneficiary-info-label">姓名</span>
            <span class="beneficiary-info-value">{{ displayName }}</span>
          </div>
          <div class="beneficiary-info-row">
            <span class="beneficiary-info-label">电话</span>
            <span class="beneficiary-info-value">{{ displayPhone }}</span>
          </div>
          <div class="beneficiary-info-row">
            <span class="beneficiary-info-label">证件号</span>
            <span class="beneficiary-info-value">{{ displayIdNo }}</span>
          </div>
        </div>
      </div>

      <div class="beneficiary-modal-footer">
        <button type="button" class="beneficiary-cancel-btn" @click="handleCancel">取消</button>
        <button type="button" class="beneficiary-confirm-btn" @click="handleConfirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 激活权益卡前 - 权益人信息核验弹框
 */
export default {
  name: 'ActivateBeneficiaryConfirmModal',
  props: {
    /** @type {boolean} */
    visible: {
      type: Boolean,
      default: false
    },
    /** @type {{ name?: string, phone?: string, idNo?: string }} */
    beneficiary: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    /**
     * 展示姓名
     * @returns {string}
     */
    displayName() {
      return this.formatValue(this.beneficiary.name)
    },
    /**
     * 展示电话
     * @returns {string}
     */
    displayPhone() {
      return this.formatValue(this.beneficiary.phone)
    },
    /**
     * 展示证件号
     * @returns {string}
     */
    displayIdNo() {
      return this.formatValue(this.beneficiary.idNo)
    }
  },
  methods: {
    /**
     * 格式化展示值
     * @param {*} value
     * @returns {string}
     */
    formatValue(value) {
      const text = String(value || '').trim()
      return text || '--'
    },
    /**
     * 取消核验
     */
    handleCancel() {
      this.$emit('cancel')
    },
    /**
     * 确认核验
     */
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.beneficiary-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(2px);
}

.beneficiary-modal {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.beneficiary-modal-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 44px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.beneficiary-modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #111111;
  line-height: 1.4;
}

.beneficiary-modal-close {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  color: #999999;
}

.beneficiary-modal-close:hover {
  background: #f5f5f5;
}

.beneficiary-modal-content {
  padding: 18px 20px 8px;
}

.beneficiary-modal-tip {
  margin: 0 0 16px;
  font-size: 14px;
  color: #555555;
  line-height: 1.75;
  text-align: justify;
}

.beneficiary-info-card {
  padding: 14px 16px;
  border-radius: 12px;
  background: #f8fbf9;
  border: 1px solid #e3ece7;
}

.beneficiary-info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 0;
}

.beneficiary-info-row + .beneficiary-info-row {
  border-top: 1px dashed #e8ece9;
}

.beneficiary-info-label {
  flex-shrink: 0;
  width: 52px;
  font-size: 14px;
  color: #888888;
  line-height: 1.5;
}

.beneficiary-info-value {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: #111111;
  line-height: 1.5;
  word-break: break-all;
}

.beneficiary-modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 20px 20px;
}

.beneficiary-cancel-btn,
.beneficiary-confirm-btn {
  flex: 1;
  height: 44px;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.beneficiary-cancel-btn {
  background: #f5f5f5;
  color: #666666;
}

.beneficiary-confirm-btn {
  background: linear-gradient(135deg, #00c275 0%, #00a86b 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.28);
}

.beneficiary-cancel-btn:active,
.beneficiary-confirm-btn:active {
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/components/ActivateBeneficiaryConfirmModal.vue